const WUR_ACTIONS_WITHOUT_YEAR = ['wur:viewInstitution'];

const WUR_EMBARGO_ACTIONS = ['wur:viewEmbargo'];

const WUR_VIEW_ACTIONS = ['wur:viewRelease', 'wur:viewInstitutionData'];

const WUR_OVERALL_ACTIONS = [
  'wur:viewInstitutionGroup',
  'wur:viewReleaseBanding',
  'wur:viewSubjectOverall',
  'wur:viewSubjectResultOverall',
  'wur:viewSubjectResultScoreOverall',
  'wur:viewSubjectResultRankOverall',
  'wur:viewSubjectAggregateDataOverall',
  'wur:viewPillarOverall',
  'wur:viewPillarAggregateDataOverall',
  'wur:viewPillarResultOverall',
  'wur:viewPillarResultScoreOverall',
  'wur:viewPillarResultRankOverall',
  'wur:viewMetricOverall',
  'wur:viewMetricAggregateDataOverall',
  'wur:viewMetricResultOverall',
  'wur:viewMetricResultValueOverall',
  'wur:viewMetricResultScoreOverall',
  'wur:viewMetricAggregateDataOverall',
  'wur:viewInstitutionSubjectData',
];

const WUR_ACTIONS = [
  ...WUR_OVERALL_ACTIONS,
  'wur:viewSubject',
  'wur:viewSubjectAggregateData',
  'wur:viewSubjectResult',
  'wur:viewSubjectResultScore',
  'wur:viewSubjectResultRank',
  'wur:viewPillar',
  'wur:viewPillarAggregateData',
  'wur:viewPillarResult',
  'wur:viewPillarResultScore',
  'wur:viewPillarResultRank',
  'wur:viewMetric',
  'wur:viewMetricAggregateData',
  'wur:viewMetricResult',
  'wur:viewMetricResultScore',
  'wur:viewMetricResultValue',
  'wur:viewMetricResultRank',
];

const WUR_DATAPLUS_ADVANCED_ACTIONS = [
  ...WUR_ACTIONS,
  'wur:viewCluster',
  'wur:viewClusterResult',
  'wur:viewDetailedSubject',
  'wur:viewDetailedSubjectAggregateData',
  'wur:viewDetailedSubjectMetric',
  'wur:viewDetailedSubjectResult',
  "wur:viewDetailedSubjectResultScore",
  "wur:viewDetailedSubjectMetricResult",
  "wur:viewDetailedSubjectMetricResultScore",
  'wur:viewDetailedSubjectMetricAggregateData',
  'wur:viewBibliometricSubject',
  'wur:viewBibliometricSubjectResult',
  'wur:viewBibliometricSubjectAggregateData',
];

module.exports = {
  WUR_EMBARGO_ACTIONS,
  WUR_VIEW_ACTIONS,
  WUR_OVERALL_ACTIONS,
  WUR_ACTIONS,
  WUR_DATAPLUS_ADVANCED_ACTIONS,
  WUR_ACTIONS_WITHOUT_YEAR,
};
